/* eslint-disable @typescript-eslint/naming-convention */
import { v4 as uuidv4 } from 'uuid'

import { iStorageApi } from './browser-store'
import { composeUrlWithParams } from './compose-url-with-params'
import { PARAMS, STORE } from './constants'
import { getCodes } from './pkce'

export interface iToRedirectConfig {
  withState?: boolean
  browserStore: iStorageApi
  authServerLoginUri: string
  client_id: string
  redirect_uri?: string
  scope?: string
  additionalParams?: Record<string, string>
}

const toRedirect = async ({
  withState,
  browserStore,
  authServerLoginUri,
  client_id,
  redirect_uri,
  scope,
  additionalParams,
}: iToRedirectConfig): Promise<never> => {
  const { code_verifier, code_challenge } = await getCodes()
  const state = uuidv4()
  const nonce = uuidv4()

  browserStore.toStore(STORE.code_verifier, code_verifier)

  if (withState) browserStore.toStore(STORE.state, state)

  console.log('code_v', code_verifier)
  console.log('code_challenge', code_challenge)
  console.log('state', state)

  const { urlWithQueryParams } = composeUrlWithParams({
    url: authServerLoginUri,
    params: {
      response_type: PARAMS.code,
      client_id,
      code_challenge,
      code_challenge_method: 'S256',
      nonce,
      ...(redirect_uri !== undefined
        ? { redirect_uri }
        : { redirect_uri: window.location.href }),
      ...(scope !== undefined ? { scope } : undefined),
      ...(withState ? { state } : undefined),
      ...(additionalParams !== undefined
        ? additionalParams
        : undefined),
    },
  })
  console.log('urlWithQueryParams', urlWithQueryParams)
  window.location.assign(urlWithQueryParams)
  return new Promise(() => {}) // never resolves — page will navigate away
}

export { toRedirect }
